import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AdminDatePicker } from '.';

interface IStartSessionDatePickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
}

export const StartSessionDatePicker = (props: IStartSessionDatePickerProps) => {
  return (
    <AdminDatePicker
      {...props}
      label={<FormattedMessage id='addSession:startDate' />}
    />
  )
};
